import React from 'react';
import Badge from './Badge';
import {
  ORDER_STATUS_LABELS,
  PAYMENT_STATUS_LABELS,
  STORE_STATUS_LABELS,
  USER_STATUS_LABELS,
  formatEnum,
} from '../../utils/enums';

// Cores por valor canônico. Labels vêm de `utils/enums.js` (fonte única).
// Se um status novo aparecer e não tiver cor mapeada, cai em 'neutral'.
const ORDER_COLORS = {
  PENDING: 'warning',
  PAID: 'success',
  CANCELED: 'error',
  REFUNDED: 'info',
  pending: 'neutral',
  awaiting_approval: 'warning',
  approved: 'info',
  rejected: 'error',
  paid: 'success',
  shipped: 'info',
  delivered: 'success',
  cancelled: 'neutral',
  refunded: 'info',
};

const PAYMENT_COLORS = {
  pending: 'warning',
  confirmed: 'success',
  paid: 'success',
  received: 'success',
  overdue: 'error',
  cancelled: 'neutral',
  refunded: 'neutral',
  failed: 'error',
};

const STORE_COLORS = {
  active: 'success',
  trial: 'info',
  suspended: 'warning',
  inactive: 'neutral',
  blocked: 'error',
  pending: 'neutral',
};

const USER_COLORS = {
  active: 'success',
  inactive: 'neutral',
  suspended: 'warning',
  blocked: 'error',
  pending: 'neutral',
};

const DOMAINS = {
  order: { labels: ORDER_STATUS_LABELS, colors: ORDER_COLORS },
  payment: { labels: PAYMENT_STATUS_LABELS, colors: PAYMENT_COLORS },
  store: { labels: STORE_STATUS_LABELS, colors: STORE_COLORS },
  user: { labels: USER_STATUS_LABELS, colors: USER_COLORS },
};

const StatusBadge = ({ status, domain = 'order', size = 'sm', variant = 'soft', className = '' }) => {
  const cfg = DOMAINS[domain] || DOMAINS.order;
  const normalized = typeof status === 'string' ? status.trim() : status;
  const label = formatEnum(cfg.labels, normalized) || '—';
  const color = cfg.colors[normalized] || cfg.colors[String(normalized).toLowerCase()] || 'neutral';
  return (
    <Badge color={color} variant={variant} size={size} className={className} dot>
      {label}
    </Badge>
  );
};

export default StatusBadge;
